/* White November — PDP gallery lightbox (checklist item 34).
   Full-screen viewer for product images: click to open, arrow-key and
   swipe navigation between every image on the piece, escape to close,
   focus trapped inside the dialog while open. Pure front-end — never
   touches the add-to-cart form, variant JSON or price. Reuses the same
   .wn-lightbox visual language as the bespoke gallery (wn-gallery.css),
   but is a separate instance keyed to its own data-wn-pdp-* attributes
   so it never collides with wn-gallery.js on pages that have both. */
(function () {
  function initPdpLightbox() {
    var box = document.querySelector('[data-wn-pdp-lightbox]');
    var dataEl = document.querySelector('[data-wn-pdp-gallery-data]');
    var triggers = document.querySelectorAll('[data-wn-pdp-lightbox-open]');
    if (!box || !dataEl || !triggers.length) return;

    var images;
    try {
      images = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!images || !images.length) return;

    var img = box.querySelector('[data-wn-pdp-lightbox-img]');
    var counter = box.querySelector('[data-wn-pdp-lightbox-counter]');
    var scrim = box.querySelector('[data-wn-pdp-lightbox-scrim]');
    var closeBtn = box.querySelector('[data-wn-pdp-lightbox-close]');
    var prevBtn = box.querySelector('[data-wn-pdp-lightbox-prev]');
    var nextBtn = box.querySelector('[data-wn-pdp-lightbox-next]');

    var index = 0;
    var lastFocused = null;
    var touchStartX = null;
    var touchStartY = null;

    function trapTargets() {
      return [closeBtn, prevBtn, nextBtn].filter(function (el) { return el; });
    }

    function isOpen() {
      return box.getAttribute('data-open') === 'true';
    }

    function show(i) {
      index = (i + images.length) % images.length;
      var item = images[index];
      img.src = item.src;
      img.alt = item.alt || '';
      if (counter) counter.textContent = (index + 1) + ' / ' + images.length;
    }

    function open(i) {
      lastFocused = document.activeElement;
      show(i);
      box.setAttribute('data-open', 'true');
      box.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      box.setAttribute('data-open', 'false');
      box.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      img.src = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function () {
        open(parseInt(t.getAttribute('data-index'), 10) || 0);
      });
    });

    if (scrim) scrim.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        show(index - 1);
        prevBtn.focus();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        show(index + 1);
        nextBtn.focus();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;

      if (e.key === 'Escape') {
        close();
        return;
      }
      if (images.length > 1 && e.key === 'ArrowLeft') {
        show(index - 1);
        return;
      }
      if (images.length > 1 && e.key === 'ArrowRight') {
        show(index + 1);
        return;
      }
      if (e.key === 'Tab') {
        var targets = trapTargets();
        if (!targets.length) return;
        var first = targets[0];
        var last = targets[targets.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    box.addEventListener('touchstart', function (e) {
      if (!isOpen() || images.length < 2) return;
      var t = e.changedTouches[0];
      touchStartX = t.clientX;
      touchStartY = t.clientY;
    }, { passive: true });

    box.addEventListener('touchend', function (e) {
      if (!isOpen() || images.length < 2 || touchStartX === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - touchStartX;
      var dy = t.clientY - touchStartY;
      touchStartX = null;
      touchStartY = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) show(index + 1);
      else show(index - 1);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpLightbox);
  } else {
    initPdpLightbox();
  }
})();
